import { type useStateTextModalType } from './TextModal'
import { ref } from 'vue'

const useStateTextModalData = ref<useStateTextModalType>({
  textModal: {
    title: '',
    subTitle: '',
    textList: [],
    lastUpdatedText: '',
    customButton: { closeButton: { title: '' } },
  },
  show: false,
  accept: () => {},
  close: () => {},
})

export const setTextModal = (textModalType: useStateTextModalType) => {
  useStateTextModalData.value = textModalType
}

export const getTextModal = () => {
  return useStateTextModalData
}
